import type { ReportPageSize } from '../../../components/ui';

export const CREW_LIST_PRINT_KEYS = ['imo', 'onboard', 'wages'] as const;
export type CrewListPrintKey = (typeof CREW_LIST_PRINT_KEYS)[number];

export function isCrewListPrintKey(value: string | null | undefined): value is CrewListPrintKey {
  return !!value && (CREW_LIST_PRINT_KEYS as readonly string[]).includes(value);
}

export const CREW_LIST_PRINT_META: Record<
  CrewListPrintKey,
  {
    title: string;
    subtitle: string;
    printPageSize: ReportPageSize;
  }
> = {
  imo: {
    title: 'IMO Crew List',
    subtitle: 'FAL Form 5 · arrival / departure crew list',
    printPageSize: 'A4 landscape',
  },
  onboard: {
    title: 'Onboard Crew List',
    subtitle: 'Portrait · rank, nationality, sign-on and COE',
    printPageSize: 'A4 portrait',
  },
  wages: {
    title: 'Crew Wages & Contracts',
    subtitle: 'Portrait · wage, sign-on, intention and COE dates',
    printPageSize: 'A4 portrait',
  },
};

/** Voyage fields collected before IMO crew list preview. */
export type ImoCrewListPrintDetails = {
  portName: string;
  arrivalDate: string;
  voyageNumber: string;
  lastPort: string;
  isArrival: boolean;
  isDeparture: boolean;
};

export function crewListPrintPath(
  key: CrewListPrintKey,
  applied: { vesselId: string; periodFrom: string; periodTo: string },
  imo?: ImoCrewListPrintDetails,
): string {
  const qs = new URLSearchParams({
    vesselId: applied.vesselId,
    periodFrom: applied.periodFrom,
    periodTo: applied.periodTo,
  });
  if (key === 'imo' && imo) {
    if (imo.portName.trim()) qs.set('port', imo.portName.trim());
    if (imo.arrivalDate.trim()) qs.set('arrivalDate', imo.arrivalDate.trim());
    if (imo.voyageNumber.trim()) qs.set('voyage', imo.voyageNumber.trim());
    if (imo.lastPort.trim()) qs.set('lastPort', imo.lastPort.trim());
    if (imo.isArrival) qs.set('arrival', '1');
    if (imo.isDeparture) qs.set('departure', '1');
  }
  return `/crew/list/print/${key}?${qs.toString()}`;
}
